module.exports = __webpack_public_path__ + "static/media/icon.1f809450.png";